<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ heading }}</p>
        </header>

        <form @submit.prevent="handleContact">
            <section class="modal-card-body">
                <div v-if="quickAdd">
                    <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                      <template #label>
                        Email <span style="color: red">*</span>
                      </template>
                        <o-input v-model="copy.email" tabindex="0" id="contact-email" />
                    </o-field>

                    <o-field label="First Name" :type="fieldType('first_name')" :message="getError('first_name')">
                      <template #label>
                        First Name <span style="color: red">*</span>
                      </template>
                        <o-input v-model="copy.first_name" tabindex="1" />
                    </o-field>

                    <o-field label="Last Name" :type="fieldType('last_name')" :message="getError('last_name')">
                      <template #label>
                        Last Name <span style="color: red">*</span>
                      </template>
                        <o-input v-model="copy.last_name" tabindex="2" />
                    </o-field>

                    <o-field label="Address" :type="fieldType('address_1')" :message="getError('address_1')">
                        <o-input v-model="copy.address_1" tabindex="3" />
                    </o-field>

                    <o-field label="Lead Owner">
                        <autocomplete-select type="user" v-model="copy.lead_owner" :error="getError('lead_owner')" />
                    </o-field>

                    <div class="columns mb-0">
                        <div class="column">
                            <o-field label="Telephone" :type="fieldType('telephone')" :message="getError('telephone')">
                                <o-input v-model="copy.telephone"  tabindex="6" />
                            </o-field>
                        </div>
                        <div class="column">
                            <o-field label="Mobile" :type="fieldType('mobile')" :message="getError('mobile')">
                                <o-input v-model="copy.mobile" tabindex="7" />
                            </o-field>
                        </div>
                    </div>

                    <o-field label="Company" v-if="showCompanyField">
                        <autocomplete-select type="company" v-model="copy.company_id" :error="getError('company_id')"/>
                    </o-field>

                    <o-field label="Fax" :type="fieldType('fax')" :message="getError('fax')">
                        <o-input v-model="copy.fax" tabindex="8" />
                    </o-field>

                    <div class="columns mb-0">
                        <div class="column">
                            <o-field label="Address 1" :type="fieldType('address_1')" :message="getError('address_1')">
                                <o-input v-model="copy.address_1"  tabindex="10" />
                            </o-field>

                            <o-field label="City" :type="fieldType('city')" :message="getError('city')">
                                <o-input v-model="copy.city"  tabindex="12"/>
                            </o-field>
                        </div>
                        <div class="column">
                            <o-field label="Address 2" :type="fieldType('address_2')" :message="getError('address_2')">
                                <o-input v-model="copy.address_2" tabindex="11" />
                            </o-field>

                            <o-field label="State" :type="fieldType('state')" :message="getError('state')">
                                <autocomplete-select type="state" v-model="copy.state" :tabindex="13" />
                            </o-field>
                        </div>
                    </div>

                    <o-field label="Zip" :type="fieldType('zip')" :message="getError('zip')">
                        <o-input v-model="copy.zip" tabindex="14" />
                    </o-field>
                </div>

                <o-tabs v-else v-model="tabIndex">
                    <o-tab-item :value="0" label="General">
                        <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                          <template #label>
                            Email <span style="color: red">*</span>
                          </template>
                            <o-input type="email" placeholder="company@example.com" v-model="copy.email" tabindex="3" />
                        </o-field>
                        <div class="columns">
                            <div class="column">
                                <o-field label="First Name" :type="fieldType('first_name')" :message="getError('first_name')">
                                  <template #label>
                                    First Name <span style="color: red">*</span>
                                  </template>
                                    <o-input v-model="copy.first_name" tabindex="4" />
                                </o-field>
                                <o-field label="Telephone" :type="fieldType('telephone')" :message="getError('telephone')">
                                    <o-input v-model="copy.telephone"  tabindex="6" />
                                </o-field>
                            </div>
                            <div class="column">
                                <o-field label="Last Name" :type="fieldType('last_name')" :message="getError('last_name')">
                                  <template #label>
                                    Last Name <span style="color: red">*</span>
                                  </template>
                                    <o-input v-model="copy.last_name" tabindex="5" />
                                </o-field>

                                <o-field label="Mobile" :type="fieldType('mobile')" :message="getError('mobile')">
                                    <o-input v-model="copy.mobile" tabindex="7" />
                                </o-field>
                            </div>
                        </div>
                        <o-field label="Company">
                            <autocomplete-select type="company" v-model="copy.company_id" :error="getError('company_id')"/>
                        </o-field>
                        <o-field label="Lead Owner">
                            <autocomplete-select type="user" v-model="copy.lead_owner" :error="getError('lead_owner')" />
                        </o-field>
                        <o-field label="Fax" :type="fieldType('fax')" :message="getError('fax')">
                            <o-input v-model="copy.fax" tabindex="8" />
                        </o-field>
                        <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                            <o-input v-model="copy.title" tabindex="9" />
                        </o-field>

                        <div class="columns">
                            <div class="column">
                                <o-field label="Address 1" :type="fieldType('address_1')" :message="getError('address_1')">
                                    <o-input v-model="copy.address_1"  tabindex="10" />
                                </o-field>

                                <o-field label="City" :type="fieldType('city')" :message="getError('city')">
                                    <o-input v-model="copy.city"  tabindex="12"/>
                                </o-field>
                            </div>
                            <div class="column">
                                <o-field label="Address 2" :type="fieldType('address_2')" :message="getError('address_2')">
                                    <o-input v-model="copy.address_2" tabindex="11" />
                                </o-field>

                                <o-field label="State" :type="fieldType('state')" :message="getError('state')">
                                    <autocomplete-select type="state" v-model="copy.state" :tabindex="13" />
                                </o-field>
                            </div>
                        </div>

                        <o-field label="Zip" :type="fieldType('zip')" :message="getError('zip')">
                            <o-input v-model="copy.zip" tabindex="14" />
                        </o-field>
                    </o-tab-item>
                    <o-tab-item :value="1" label="License Number" class="licenses">
                        <template v-if="copy.licenses">
                            <o-field label="TAX ID">
                                <o-input placeholder="Tax ID" v-model="copy.tax_id" tabindex="3" />
                            </o-field>
                            <hr>
                            <o-field label="PE">
                                <o-input placeholder="License #" v-model="copy.licenses.PE.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.PE.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="SIA">
                                <o-input placeholder="License #" v-model="copy.licenses.SIA.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.SIA.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="FSC">
                                <o-input placeholder="License #" v-model="copy.licenses.FSC.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.FSC.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="SH">
                                <o-input placeholder="License #" v-model="copy.licenses.SH.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.SH.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="SOC">
                                <o-input placeholder="License #" v-model="copy.licenses.SOC.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.SOC.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="RA">
                                <o-input placeholder="License #" v-model="copy.licenses.RA.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.RA.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="MP">
                                <o-input placeholder="License #" v-model="copy.licenses.MP.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.MP.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="GC">
                                <o-input placeholder="License #" v-model="copy.licenses.GC.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.GC.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />

                            <o-field label="SSM" :type="fieldType('SSM')" :message="getError('SSM')">
                                <o-input placeholder="License #" v-model="copy.licenses.SSM.value" tabindex="3" />
                            </o-field>
                            <datepicker v-model="copy.licenses.SSM.exp_date"
                                        input-class="input is-fullwidth"
                                        placeholder="Exp. Date" :absolute="false"
                            />
                        </template>
                    </o-tab-item>
                    <o-tab-item :value="2" label="Credentials">
                        <o-field label="User Name" :type="fieldType('user_name')" :message="getError('user_name')">
                            <o-input v-model="copy.user_name" />
                        </o-field>
                        <o-field label="Password" :type="fieldType('password')" :message="getError('password')">
                            <o-input password-reveal type="password" autocomplete="new-password" placeholder="" v-model="copy.password" :class="'reveal-external'" />
                        </o-field>
                    </o-tab-item>
                </o-tabs >
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button class="button is-primary" tabindex="15">Save</button>
            </footer>
        </form>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
import HandlesForm from './../../mixins/HandlesForm';
import Datepicker from './../Datepicker';

    export default {
        mixins: [HandlesForm],

        components: {
            Datepicker
        },

        props: {
            quickAdd: {
                required: false,
                default: false
            },

            projectId: {
                required: false
            },

            showCompanyField: {
                default: false,
                required: false,
            },
        },

        emits:["contact-added"],


        mounted () {
            this.copy.licenses = this.copy.licenses || _.cloneDeep(this.contactLicenses)

            let project = null

            if (this.projectId) {
                project = this.projectById(this.projectId)
            }

            const companyId = project && project.company_id
                ? project.company_id
                : this.item.company_id

            if (companyId) {
                let company = this.companyById(companyId)

                this.copy.company_id = companyId

                if (! this.item.id && company.lead_owner) {
                    this.copy.lead_owner = this.userById(company.lead_owner).id
                }

                Object.assign(this.copy, {
                    address_1: (this.copy.address_1 || company.address),
                    city: company.city,
                    state: company.state,
                    zip: company.zip,
                })
            }

        },

        data () {
            return {
                tabIndex: 0,
                copy: {
                    first_name: '',
                    last_name: '',
                    telephone: '',
                    mobile: '',
                    email: '',
                    fax: '',
                    lead_owner: '',
                    licenses: null,
                    title: '',
                    address_1: '',
                    address_2: '',
                    city: '',
                    state: '',
                    zip: '',
                    company_id: null,
                    user_name: '',
                    password: ''
                }
            }
        },

        methods: {
            ...mapActions(['createOrUpdateContact', 'attachProjectContact']),

            handleContact () {
                let submit = this.wrapSubmit(this.createOrUpdateContact)

                submit(this.copy)
                    .then(res => {
                        if (this.projectId) {
                            this.attachProjectContact({
                                project_id: this.projectId,
                                contact_id: res.data.data.id
                            })
                        }

                        this.$emit('contact-added', res.data.data.id)
                        this.successMessage('Contact was successfull added')
                        
                        // Clear all form fields after successful submission
                        this.clearFormFields()
                        
                        this.$parent.$parent.close()
                        return res
                    }).catch(() => this.tabIndex = 0)
            },

            clearFormFields () {
                this.copy = {
                    first_name: '',
                    last_name: '',
                    telephone: '',
                    mobile: '',
                    email: '',
                    fax: '',
                    lead_owner: '',
                    licenses: _.cloneDeep(this.contactLicenses),
                    title: '',
                    address_1: '',
                    address_2: '',
                    city: '',
                    state: '',
                    zip: '',
                    company_id: this.item?.company_id || null,
                    user_name: '',
                    password: '',
                    tax_id: ''
                }
                this.tabIndex = 0
            },
        },

        computed: {
            ...mapGetters([
                'companies',
                'companyNameById',
                'states',
                'contactLicenses',
                'userById',
                'companyById',
                'projectById'
            ]),

            heading () {
                let referenceName = this.companyNameById(this.item.company_id)
                return this.copy.id ? `Edit ${referenceName} Contact` : `Add ${referenceName} Contact`
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    }
</style>
